'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { setToString } from '../../../core/utilities/set.utils.js';
import { useSwanI18nContext } from '../../contexts/i18n/swan-i18n-provider.context.js';
import { useAdaptiveCarouselContext } from './adaptive-carousel.context.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { Button } from '../button/button.component.js';
import { Icon } from '../icon/icon.component.js';

function _define_property(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[t] = r, e;
}
function _object_spread(e) {
    for(var t = 1; t < arguments.length; t++){
        var r = null != arguments[t] ? arguments[t] : {}, o = Object.keys(r);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(r).filter(function(e) {
            return Object.getOwnPropertyDescriptor(r, e).enumerable;
        }))), o.forEach(function(t) {
            _define_property(e, t, r[t]);
        });
    }
    return e;
}
function ownKeys(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r.push.apply(r, o);
    }
    return r;
}
function _object_spread_props(e, t) {
    return t = null != t ? t : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
        Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    }), e;
}
function _object_without_properties(e, t) {
    if (null == e) return {};
    var r, o, n = _object_without_properties_loose(e, t);
    if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);
        for(o = 0; o < i.length; o++)r = i[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
    }
    return n;
}
function _object_without_properties_loose(e, t) {
    if (null == e) return {};
    var r, o, n = {}, i = Object.keys(e);
    for(o = 0; o < i.length; o++)r = i[o], t.indexOf(r) >= 0 || (n[r] = e[r]);
    return n;
}
const AdaptiveCarouselSlidePickerThumbnail = renderWithRef('AdaptiveCarouselSlidePickerThumbnail', null, (n, p)=>{
    let { children: s, index: l = 0, video: u } = n, b = _object_without_properties(n, [
        "children",
        "index",
        "video"
    ]), { t: f } = useSwanI18nContext(), { firstVisibleSlideIndex: m, goToSlide: d } = useAdaptiveCarouselContext(), y = new Set([
        'swan-adaptive-carousel-slide-picker-thumbnail'
    ]), O = m === l;
    return O && y.add('swan-adaptive-carousel-slide-picker-thumbnail-active'), jsxs(Button, _object_spread_props(_object_spread({
        className: setToString(y),
        ref: p
    }, b), {
        skin: "unstyled",
        onClick: ()=>d(l),
        "aria-label": f('adaptive-carousel-slide-picker-thumbnail.accessible-text-for-button', {
            slideNumber: l + 1
        }),
        "aria-current": O ? 'true' : 'false',
        children: [
            s,
            u && jsx("span", {
                className: "swan-adaptive-carousel-slide-picker-thumbnail-icon",
                children: jsx(Icon, {
                    iconType: "play",
                    darkMode: true
                })
            })
        ]
    }));
});

export { AdaptiveCarouselSlidePickerThumbnail };
